export const TRACKER_DEST_CONFIG_UPDATE_WARNING = '[Dest config update warning] show warning window';
export const TRACKER_DEST_CONFIG_UPDATE_SUBMIT = '[Dest config update warning] submit click';
export const TRACKER_DEST_CONFIG_UPDATE_SUBMIT_SUCCESS = '[Dest config update warning] submit success';
export const TRACKER_DEST_CONFIG_UPDATE_SUBMIT_ERROR = '[Dest config update warning] submit error';
export const TRACKER_DEST_CONFIG_UPDATE_CANCEL = '[Dest config update warning] cancel click';

